export default "/static/media/hero.164775c9.jpg";